import React from "react";

const InfoBlock = () => {
    return (
        <section>
            <p>
                <strong>Uwaga!</strong>
            </p>
            <p>
                Zgłoszenie do Konkursu e-Commerce Polska awards 2021 łączy się z obowiązkiem uiszczenia opłaty w
                wysokości:
            </p>
            <ol>
                <li>
                    Firmy zrzeszone w e-Izbie (Organizator) w rozumieniu jego statutu:
                    <ul>
                        <li>Małe Podmioty w kwocie 299 zł netto za zgłoszenie w jednej Kategorii (z wyłączeniem kategorii Best start in e-commerce),</li>
                        <li>
                            Średnie i Duże Podmioty - przy zgłoszeniu do 31.03.2021 w kwocie 499 zł netto, przy
                            zgłoszeniu od 1.04.2021 w kwocie 799 zł netto za zgłoszenie w jednej Kategorii,
                        </li>
                        <li>
                            Banki, Zakłady Ubezpieczeń, Systemy Płatności Cyfrowych - przy zgłoszeniu do 31.03.2021 w
                            kwocie 499 zł netto, przy zgłoszeniu od 1.04.2021 w kwocie 799 zł netto za zgłoszenie w
                            jednej Kategorii,
                        </li>
                        <li>
                            E-usługi w kwocie - przy zgłoszeniu do 31.03.2021 w kwocie 499 zł netto, przy zgłoszeniu od
                            1.04.2021 w kwocie 799 zł netto za zgłoszenie w jednej Kategorii.
                        </li>
                    </ul>
                </li>
                <li>
                    Uczestnicy, którzy nie mają statusu członków lub partnerów Organizatora w rozumieniu statutu
                    Organizatora:
                    <ul>
                        <li>
                            Małe Podmioty - przy zgłoszeniu do 31.03.2021 w kwocie 499 zł netto, przy zgłoszeniu od
                            1.04.2021 w kwocie 999 zł netto za zgłoszenie w jednej Kategorii (z wyłączeniem kategorii Best start in e-commerce),
                        </li>
                        <li>
                            Średnie i Duże Podmioty - przy zgłoszeniu do 31.03.2021 w kwocie 1499 zł netto, przy
                            zgłoszeniu od 1.04.2021 w kwocie 1999 zł netto za zgłoszenie w jednej Kategorii,
                        </li>
                        <li>
                            Banki i Zakłady Ubezpieczeń, Systemy Płatności Cyfrowych - przy zgłoszeniu do 31.03.2021 w
                            kwocie 1499 zł netto, przy zgłoszeniu od 1.04.2021 w kwocie 1999 zł netto za zgłoszenie w
                            jednej Kategorii,
                        </li>
                        <li>
                            E-usługi - przy zgłoszeniu do 31.03.2021 w kwocie 1499 zł netto, przy zgłoszeniu od
                            1.04.2021 w kwocie 1999 zł netto za zgłoszenie w jednej Kategorii.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>
                Kwoty powiększone o należny podatek VAT należy wnosić na rachunek bankowy Organizatora prowadzony przez
                Bank (PKO BP SA Oddział 1 w Warszawie) o numerze <strong>79 1020 1013 0000 0302 0291 6963</strong>.
            </p>
        </section>
    );
};

export default InfoBlock;
